import {Outlet, createFileRoute} from "@tanstack/react-router";

import {routeMessages} from "../../../../messages/routes.messages";

export const Route = createFileRoute("/_app/sales/representatives")({
  component: () => <Outlet />,
  staticData: {
    meta: {
      labelDescriptor: routeMessages.representatives,
      moduleDescriptor: routeMessages.sales,
      nav: {order: 3, visible: true},
    },
  },
});
